// extracted by mini-css-extract-plugin
export var sbShowMain = "homepageImageText-module--sb-show-main--XwYpy";
export var wrapper = "homepageImageText-module--wrapper--3a4PZ";
export var firstImage = "homepageImageText-module--firstImage--3XICO";
export var title = "homepageImageText-module--title--1sp5y";
export var animation = "homepageImageText-module--animation--DPsGN";
export var trigger = "homepageImageText-module--trigger--SLKee";